<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M13.237 4.763A5.968 5.968 0 0 0 9 3a5.992 5.992 0 0 0-5.993 6c0 3.315 2.678 6 5.993 6a5.987 5.987 0 0 0 5.797-4.5h-1.56A4.493 4.493 0 0 1 9 13.5 4.504 4.504 0 0 1 4.5 9c0-2.482 2.017-4.5 4.5-4.5 1.245 0 2.355.518 3.165 1.335L9.75 8.25H15V3l-1.763 1.763Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
